module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[9]496.15b254f.woff2";